import React, {
  BaseSyntheticEvent, MutableRefObject, useEffect, useRef, useState,
} from 'react';
import Page from 'src/layout/Page';
import './signup.css';
import usePost from 'src/hooks/usePost';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SignUp: React.FC = (): React.ReactElement => {
  const [isValid, setIsValid] = useState<boolean>(false);
  const formRef = useRef() as MutableRefObject<HTMLFormElement>;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const {
    makeRequest,
    invalidateError,
    data,
    error,
    loading,
  } = usePost();

  useEffect(() => {
    document.title = t('pages.signup.title');
  }, [i18n.language]);

  useEffect(() => {
    let timeoutId: number | undefined;
    if (data && data.success) {
      formRef.current.reset();
      timeoutId = setTimeout(() => {
        invalidateError();
				if (i18n.language !== 'en') {
					navigate('/ְּנִיסָה-לַמַעֲרֶכֶת');
				} else {
					navigate('/en/login');
				}
      }, 2000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [data]);

  const handleSignUp = async (e: BaseSyntheticEvent) => {
    e.preventDefault();
    invalidateError();
    const formData = Object.fromEntries(new FormData(formRef.current));
    if (formRef.current.checkValidity() && formData.password === formData.passwordConfirm) {
      await makeRequest('auth/signup', true, {
        ...formData,
        socialProvider: 'LOCAL',
        confirmed: true,
        language: 'ENG',
      });
    }
  };

  const checkValidity = () => {
    invalidateError();
    const formData = Object.fromEntries(new FormData(formRef.current));
    if (formRef.current.checkValidity() && formData.password === formData.passwordConfirm) {
      setIsValid(true);
      return true;
    }
    setIsValid(false);
    return false;
  };

  return <Page pageClass={'login-page'} pageHeader={t('pages.signup.title')}>
    <form className={'signup-form'} ref={formRef}>
      <input name={'email'} id={'email'} type="email" placeholder={t('pages.signup.email')} required onInput={checkValidity}/>
      <input name={'phone'} id={'phone'} type="text" placeholder={t('pages.signup.phone')} required onInput={checkValidity}/>
      <input name={'firstname'} id={'firstname'} type="text" placeholder={t('pages.signup.firstName')} required onInput={checkValidity}/>
      <input name={'lastname'} id={'lastname'} type="text" placeholder={t('pages.signup.lastName')} required onInput={checkValidity}/>
      <input name={'password'} id={'password'} type="password" placeholder={t('pages.signup.password')} required onInput={checkValidity}/>
      <input name={'passwordConfirm'} id={'passwordConfirm'} type="password" placeholder={t('pages.signup.confirmPassword')} required
             onInput={checkValidity}/>
      <button type={'submit'} className={'scroll-to-button active'} onClick={handleSignUp} disabled={!isValid || loading}>
        {t('pages.signup.signup')}
      </button>
      {error && (
        <div className="error">{error?.message || (error as any)?.error}</div>
      )}
      {
        data && data.success && (
          <div className="success">{data?.message}</div>
        )
      }
    </form>
  </Page>;
};

export default SignUp;
